import { render, staticRenderFns } from "./ModalWarningGeneral.vue?vue&type=template&id=0f43954f&"
import script from "./ModalWarningGeneral.vue?vue&type=script&lang=js&"
export * from "./ModalWarningGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports